

<template>
  <div>
    <Menubar :model="items">
      <template #end>
        <div>
          <Dropdown 
            v-if="isAdmin"
            :value="current"
            :options="companies" 
            :filter="true" 
            placeholder="Velg bedrift" 
            optionLabel="companyname"
            @change="changeSelected"
          ></Dropdown>
          <Button label="Logg ut" class="p-button-text p-button-secondary" @click="logout"/>
        </div>
      </template>
    </Menubar>
  </div>
  
</template>

<script>
import { signout } from '@/firebase/signout' 

import Menubar from 'primevue/menubar';
import Dropdown from 'primevue/dropdown';

export default {
name: 'navmenu',
components: {
  Menubar,
  Dropdown
},

methods: {
  logout(){
    signout()
  },
  changeSelected(event){
    this.$store.dispatch('companies/current', event.value).then(() => {
      this.$router.push({name: 'projects', query: {id: event.value.id}})
    })
  }
},

computed: {
  companies(){
    return this.$store.getters["companies/list"]
  },
  
  current(){
    return this.$store.getters["companies/current"]
  }, 
  
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  },
  
  items(){
    return[
      {
        label: this.current.companyname, 
        to: '/'
      },
      {
        label: 'Prosjekter',
        to: '/projects',
        icon: 'pi pi-list',
      },
      {
        label: 'Nytt prosjekt',
        to: '/projectAdd',
        icon: 'pi pi-plus'
      },
      {
        label: 'Ansatte',
        to: '/employees',
        icon: 'pi pi-users'
      },
      {
        label: 'Bedrifter',
        to: '/companies',
        icon: 'pi pi-sitemap',
        visible: this.isAdmin
      }
    ]
  },
},


}
</script>